import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';
import { Grid, TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import EditIcon from '@mui/icons-material/Edit';
import useSubmitLock from '../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export default function EditarUser(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = React.useState(false);
    const [datauser, setDaraUser] = React.useState({
        guid: props.guid,
        nombre: props.nombre,
        apellido: props.apellido,
        email: props.email,

    })
    const { obteneruser } = props
    const [rol, setRol] = React.useState(props.rol);
    const { submitting, runWithSubmitLock } = useSubmitLock();

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleClickVariant = (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });
    };

    const handleChangerol = (event) => {
        setRol(event.target.value);
    };



    const adduser = (e) => {
        e.preventDefault()
        runWithSubmitLock(async () => {
        if (datauser.password === datauser.password2) {

            const token = sessionStorage.getItem('%t')
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "guid": datauser.guid,
                "nombre": datauser.nombre,
                "apellido": datauser.apellido,
                "email": datauser.email,
                "password": datauser.password,
                "rol": rol
            });

            var requestOptions = {
                method: 'PATCH',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            try {
                const response = await fetch(`${REACT_APP_API_URL}/usuarios`, requestOptions)
                const resultado = await response.json();
                return (setDaraUser({}), handleClickVariant(resultado), setOpen(false), obteneruser())
            } catch (error) {
                console.log('Algo salio mal', error);
            }
        } else (
            console.log('Dato no esta completo')
        )
        })
    }


    return (
        <>
            <IconButton onClick={handleClickOpen}>
                <EditIcon />
            </IconButton>


            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth='lg'
            >

                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Agregar usuario
                </BootstrapDialogTitle>
                <form onSubmit={adduser}>
                    <DialogContent dividers>
                        <br />
                        <Grid container>
                            <Grid item>
                                <FormControl fullWidth sx={{ minWidth: 200 }}>
                                    <Select
                                        required
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={rol}
                                        variant='filled'
                                        defaultValue={props.rol}
                                        label="rol"
                                        onChange={handleChangerol}
                                    >
                                        <MenuItem value={3}>Capturista</MenuItem>
                                        <MenuItem value={7}>Supervisor</MenuItem>
                                        <MenuItem value={13}>Administrador</MenuItem>
                                    </Select>
                                    <FormHelperText>Rol del usuario*</FormHelperText>
                                </FormControl>

                            </Grid>
                        </Grid>
                        <br />
                        <Grid container spacing={2}>
                            <Grid item>
                                <TextField
                                    required
                                    defaultValue={datauser.nombre}
                                    variant='standard'
                                    helperText='Nombre*'
                                    onChange={e => setDaraUser({ ...datauser, nombre: e.target.value })}
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    defaultValue={datauser.apellido}
                                    required
                                    variant='standard'
                                    helperText='Apellido*'
                                    onChange={e => setDaraUser({ ...datauser, apellido: e.target.value })}
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    required
                                    defaultValue={datauser.email}
                                    type='email'
                                    variant='standard'
                                    helperText='Correo electronico*'
                                    onChange={e => setDaraUser({ ...datauser, email: e.target.value })}
                                />
                            </Grid>
                        </Grid>
                        <br />
                    </DialogContent>
                    <Grid container justifyContent='flex-end' alignItems='flex-end' spacing={2} style={{ padding: '9px' }}>
                        <Grid item >
                            <Button autoFocus color='success' variant='outlined' type='submit' disabled={submitting}>
                                Actualizar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </BootstrapDialog>
        </>
    );
}